// extracted by mini-css-extract-plugin
export var date = "projects-module--date--c2900";
export var description = "projects-module--description--1d977";
export var excerpt = "projects-module--excerpt--2e8b2";
export var post = "projects-module--post--c36de";
export var preview = "projects-module--preview--9cc1b";
export var projectsContainer = "projects-module--projectsContainer--be315";